import { render } from "./CodeToolbar.vue?vue&type=template&id=3ffb82f2"
import script from "./CodeToolbar.vue?vue&type=script&lang=js"
export * from "./CodeToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__